module.exports = __webpack_public_path__ + "static/img/hhd_vip_02.565d4e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/hhd_vip_02.jpg
// module id = jX28
// module chunks = 1